/**
 * FlatButton.js
 * Minimal text button with subtle hover
 *
 * @class FlatButton
 * @author  Randy Lebeau
 * @contributor Yevgeniy Rokhlin
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import PropsJoin from 'mixins/js/PropsJoin';
import EnhancedButton from 'components/buttons/enhanced-button/EnhancedButton';

export default React.createClass({


	displayName: "FlatButton",

	mixins: [ PropsJoin ],

	propTypes: {
		classes: React.PropTypes.string,
		status: React.PropTypes.string,
		label: function(props, propName, componentName) {
			if (!props.children && !props.label) {
				return new Error('Warning: Required prop `label` or `children` was not specified in `' + componentName + '`.')
			}
		},
	},

	getDefaultProps(){
		return {
			status: "primary"
		}
	},

	render() {

		let label = this.props.label,
			primary = this.props.primary,
			secondary = this.props.secondary;

		let classes = ClassNames('lui-flat-button', this.props.className, `lui-is-${this.props.status}`);

		let children;

		if (label) {
			children = <span className="lui-flat-button-label">{label}</span>
		} else {
			children = this.props.children;
		}

		return (
			<EnhancedButton {...this.props}
				className={classes}>
				{children}
			</EnhancedButton>
		);
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/buttons/flat-button/FlatButton.js
 **/